import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  DEFAULT_LOGO_RATIO,
  getLogoRatioFromImageProperties
} from '@constants/file';
import { CustomFieldConfig } from '@features/member-management/types';
import { ImageProperties, LogoRatio } from '@types';

interface BranchConfigState {
  memberCustomFields: CustomFieldConfig[];
  logoRatio: LogoRatio;
}

const initialState: BranchConfigState = {
  memberCustomFields: [],
  logoRatio: DEFAULT_LOGO_RATIO
};

export const branchConfigSlice = createSlice({
  name: 'branchConfig',
  initialState,
  reducers: {
    setMemberCustomFields: (
      state,
      action: PayloadAction<CustomFieldConfig[]>
    ) => {
      state.memberCustomFields = action.payload;
    },
    setBranchLogoRatio: (
      state,
      action: PayloadAction<ImageProperties | null | undefined>
    ) => {
      state.logoRatio = getLogoRatioFromImageProperties(action.payload);
    },
    resetBranchConfig: () => initialState
  }
});

export const { setMemberCustomFields, setBranchLogoRatio, resetBranchConfig } =
  branchConfigSlice.actions;
export default branchConfigSlice.reducer;
